import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { Link, useParams } from 'react-router-dom';
import { spacing } from '@mui/system';
import { useSnackbar } from 'notistack';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box, Link as MuiLink } from '@mui/material';
import { PATH_SUPPLIER } from '../../constants';
import SupplierCollection from '../../components/supplier/SupplierFormComponents/SupplierDetails/SupplierContainers';
import { supplierAPI } from '../../services';
import useLogOut from '../../hooks/useLogOut';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SupplierCollectionPage: React.FC = () => {
  // USE HOOKS
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [errStatus, setErrStatus] = useState(null);
  const { logOut } = useLogOut(errStatus);
  // FETCH SUPPLIER
  const {
    data: supplierData = {},
    refetch,
    error
  } = supplierAPI.useFetchSupplierCollectionQuery({ id }, { refetchOnMountOrArgChange: true });
  // HANDLERS
  const errorHandler = (error: any) => {
    let message: string | any = 'Something went wrong!';
    if (error?.data?.errors) {
      const msg = Object.values(error?.data?.errors).map((item: any) => item?.message || item);
      message = msg[0];
    }
    if (error?.originalStatus === 401) {
      setErrStatus(error?.originalStatus);
      message = 'You are not authorized!';
    }
    enqueueSnackbar(message, {
      variant: 'error'
    });
  };
  // HOOKS
  useEffect(() => {
    if (error) errorHandler(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  useEffect(() => {
    if (errStatus && typeof logOut === 'function') {
      logOut();
    }
  }, [errStatus, logOut]);
  return (
    <React.Fragment>
      <Box sx={{ mb: 5 }}>
        <Typography variant="h3" gutterBottom>
          Edit Supplier Details
        </Typography>
        <Breadcrumbs>
          <MuiLink component={Link} to={PATH_SUPPLIER.ROOT}>
            Phoenix Waste Collection
          </MuiLink>
          <Typography>Vehicle/Container Sizes Used</Typography>
        </Breadcrumbs>
      </Box>
      <SupplierCollection
        supplier={{
          collection_ids: [null],
          collection_types_ids: [],
          ...supplierData
        }}
        refetch={refetch}
      />
    </React.Fragment>
  );
};

export default SupplierCollectionPage;
